

export const EnumToString = (e: string): string => {
    
    if (!e) {
        return "empty";
    }

    switch (e) {
        case "equipmenttype.iba": return "In-bay Automatic (IBA)";
        case "equipmenttype.tunnel": return "Tunnel";
        case "equipmenttype.selfserve": return "Self-Serve (SS)";
        case "equipmenttype.vac": return "Vacuum";
        case "equipmenttype.dispenser": return "Dispenser";

        case "interfacetrigger.remotescan": return "Remote Start";
        case "interfacetrigger.attendant": return "Attendant Scan";
        case "interfacetrigger.scanner": return "Paystation Scanner";
        case "interfacetrigger.finger": return "Keypad";
        case "interfacetrigger.magic": return "Magic";

        case "interfacetype.attendant": return "Attendant (Human)";
        case "interfacetype.paystation": return "Paystation";
        case "interfacetype.unit": return "Everwash Unit";

        case "misusestatus.created": return "Reported";
        case "misusestatus.disregard": return "Disregarded";
        case "misusestatus.update_plate": return "Update Plate";
        case "misusestatus.in_review": return "Under Review";
        case "misusestatus.needs_review": return "Needs Review";
        case "misusestatus.first_warning": return "First Warning";
        case "misusestatus.second_warning": return "Second Warning";
        case "misusestatus.final_warning": return "Final Warning";
        default: return e;
    }

}

export const stupidDateFormat = (date: Date): string => {
    if (!date) {
        date = new Date();
    }

    let year: string = date.getFullYear().toString();
    let month: string = (date.getMonth() + 1).toString(); //yTF would they do this zero based?  FUCK!
    let day: string = (date.getDate()).toString();

    if (month.length === 1) month = `0${month}`;
    if (day.length === 1) day = `0${day}`;

    return `${year}-${month}-${day}`;

}


export const fromStupidDateFormat = (date: string): Date => {

    let parts = date.split('-');
    let toReturn = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
 
    return toReturn;
}